export type DurationLike = {
  seconds?: number | string | null;
  nanos?: number | null;
};

export const LAST_ACTIVITY_AT_STORAGE_KEY = 'modernloop:last_activity_at';

export const durationToMilliseconds = (duration?: DurationLike | null): number | null => {
  if (!duration) {
    return null;
  }

  const seconds = Number(duration.seconds ?? 0);
  const nanos = Number(duration.nanos ?? 0);
  const milliseconds = seconds * 1000 + Math.floor(nanos / 1_000_000);

  return Number.isFinite(milliseconds) && milliseconds > 0 ? milliseconds : null;
};

export const parseLastActivityAt = (value: string | null): number | null => {
  if (!value) {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
};

export const shouldLogoutForInactivity = (now: number, lastActivityAt: number | null, timeoutMs: number): boolean => {
  return lastActivityAt !== null && now - lastActivityAt >= timeoutMs;
};

export const readLastActivityAt = (): number | null => {
  try {
    return parseLastActivityAt(window.localStorage.getItem(LAST_ACTIVITY_AT_STORAGE_KEY));
  } catch {
    return null;
  }
};

export const writeLastActivityAt = (value: number): void => {
  try {
    window.localStorage.setItem(LAST_ACTIVITY_AT_STORAGE_KEY, String(value));
  } catch {
    // If localStorage is unavailable, the interval check still guards this tab.
  }
};

export const clearLastActivityAt = (): void => {
  try {
    window.localStorage.removeItem(LAST_ACTIVITY_AT_STORAGE_KEY);
  } catch {
    // localStorage can be disabled in private or locked-down browser contexts.
  }
};
